/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/no-duplicate-string */
import React, { useContext, useEffect, useState } from 'react';
import CustomerInfo from '../../Rental/CreateAgreement/CustomerInfo';
//import { agreementGlobalStyles } from '../../JSstyles/agreementGlobalStyles';
import { wizardStyles } from '../../../JSstyles/wizardStyles';
import { Grid, List, ListItem, Box } from '@rentacenter/racstrap';
import { ReactComponent as CompletedIcon } from '../../../assets/images/wizard-complete.svg';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router';
import { AgreementContext } from '../../../context/AgreementContext';
import { useTranslation } from 'react-i18next';
export type CoCustomerDetails = {
  coCustomerId: string;
  coCustomerName: string;
};
export type WizardProps = {
  WizardAgrId: string;
  ItemSearchCompleted: boolean;
  AgreementDetailsCompleted: boolean;
  InitialPaymentCompleted: boolean;
  DeliveryMethodCompleted: boolean;
  CoCustomerDetails: CoCustomerDetails;
  dethrower: boolean;
};
interface Params {
  customerId: string;
  agreementId: string;
}
export default function Wizard(props: WizardProps) {
  const { i18n, t } = useTranslation('reinstatement');

  const { customerId, agreementId } = useParams<Params>();
  const history = useHistory();
  const { showProgress } = useContext(AgreementContext);
  // const classes = agreementGlobalStyles();
  const wizardClassName = wizardStyles();
  const {
    WizardAgrId,
    ItemSearchCompleted,
    AgreementDetailsCompleted,
    InitialPaymentCompleted,
    DeliveryMethodCompleted,
    CoCustomerDetails,
    dethrower,
  } = props;
  // const ActivePageCss = 'inactive active';
  // const WizardCssObj = {
  //   // eslint-disable-next-line sonarjs/no-duplicate-string
  //   ItemSearchCss: 'inactive done',
  //   AgreementDeatilsCss: ActivePageCss,
  //   InitialPaymentCss: 'inactive',
  //   DeliveryMethod: 'inactive',
  // };
  // const [WizardStatus, setWizardStatus] = useState(WizardCssObj);
  const [CocustomerDetailsValue, setCoCustomerDetails] =
    useState<CoCustomerDetails>(CoCustomerDetails);
  const [AgrId, setAgrId] = useState('');

  const dynamicClasses: any = {
    complete: {
      anchor: wizardClassName.smartWizardListLinkActive,
      spanNum: `${wizardClassName.borderDefault} ${wizardClassName.done}`,
      spanDetail: wizardClassName.stepDone,
    },
    inprogress: {
      anchor: wizardClassName.smartWizardListLinkInActive,
      spanNum: wizardClassName.borderActive,
      spanDetail: wizardClassName.stepActive,
    },
    pending: {
      anchor: wizardClassName.smartWizardListLinkInActive,
      spanNum: wizardClassName.borderDefault,
      spanDetail: wizardClassName.stepNotStarted,
    },
  };

  const [itemSearchStatus, setItemSearchStatus] = useState('pending');
  const [agreementDetailStatus, setAgreementDetailStatus] = useState('pending');
  const [initialPaymentStatus, setInitialPaymentStatus] = useState('pending');
  const [deliveryMethodStatus, setDeliveryMethodStatus] = useState('pending');

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log(
      'Inside wizard outside',
      CoCustomerDetails,
      CocustomerDetailsValue
    );
    if (
      CoCustomerDetails !== undefined &&
      CoCustomerDetails.coCustomerId !== undefined &&
      CoCustomerDetails.coCustomerId !== null &&
      CoCustomerDetails.coCustomerId !== '' &&
      CoCustomerDetails.coCustomerName !== undefined &&
      CoCustomerDetails.coCustomerName !== null &&
      CoCustomerDetails.coCustomerName !== ''
    ) {
      // eslint-disable-next-line no-console
      console.log('Inside wizard in wizard component', CoCustomerDetails);
      setCoCustomerDetails(CoCustomerDetails);
    }

    if (ItemSearchCompleted === false && AgreementDetailsCompleted === false) {
      setItemSearchStatus('inprogress');
    } else if (
      ItemSearchCompleted === true &&
      AgreementDetailsCompleted === false
    ) {
      setItemSearchStatus('complete');
      setAgreementDetailStatus('inprogress');
    } else if (
      ItemSearchCompleted === true &&
      AgreementDetailsCompleted === true &&
      InitialPaymentCompleted === true
      // eslint-disable-next-line sonarjs/no-duplicated-branches
    ) {
      setItemSearchStatus('complete');
      setAgreementDetailStatus('complete');
      setInitialPaymentStatus('complete');
      setDeliveryMethodStatus('inprogress');
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    ItemSearchCompleted,
    AgreementDetailsCompleted,
    InitialPaymentCompleted,
    DeliveryMethodCompleted,
    CoCustomerDetails,
  ]);
  useEffect(() => {
    setAgrId(WizardAgrId);
  }, [WizardAgrId]);
  const WizardFieldClick = (FieldType: any) => {
    if (FieldType == 'Itemsearch') {
      if (itemSearchStatus === 'complete') {
        history.push({
          pathname: `/agreement/reinstate/itemsearch/${customerId}/${agreementId}?coCustomerId=N`,
        });
        const navEvent = new PopStateEvent('popstate');
        window.dispatchEvent(navEvent);
      }
    } else if (FieldType == 'AgrDetails') {
      if (agreementDetailStatus === 'complete') {
        history.push({
          pathname: `/agreement/reinstate/details/${customerId}/${agreementId}?coCustomerId=N`,
        });
        const navEvent = new PopStateEvent('popstate');
        window.dispatchEvent(navEvent);
      }
    }
  };
  return (
    //Wizard starts from here
    <div data-testid="WizardTest">
      <Grid className={wizardClassName.swThemeDefault}>
        <Grid item className={wizardClassName.swThemeDefaultContainer}>
          {showProgress ? (
            <List className={wizardClassName.smartWizard}>
              <ListItem
                className={wizardClassName.smartWizardList}
                onClick={() => WizardFieldClick('Itemsearch')}
              >
                <a className={dynamicClasses[itemSearchStatus]['anchor']}>
                  {itemSearchStatus === 'complete' ? (
                    <Box
                      component="span"
                      className={`${wizardClassName.done} ${wizardClassName.borderDone}`}
                    >
                      <CompletedIcon className={wizardClassName.paddingTop3} />
                    </Box>
                  ) : (
                    <span
                      className={dynamicClasses[itemSearchStatus]['spanNum']}
                    >
                      1
                    </span>
                  )}

                  <span
                    className={dynamicClasses[itemSearchStatus]['spanDetail']}
                  >
                    {t('Item Search')}
                  </span>
                </a>
              </ListItem>
              <ListItem
                className={wizardClassName.smartWizardList}
                onClick={() => WizardFieldClick('AgrDetails')}
              >
                <a className={dynamicClasses[agreementDetailStatus]['anchor']}>
                  {agreementDetailStatus === 'complete' ? (
                    <Box
                      component="span"
                      className={`${wizardClassName.done} ${wizardClassName.borderDone}`}
                    >
                      <CompletedIcon className={wizardClassName.paddingTop3} />
                    </Box>
                  ) : (
                    <span
                      className={
                        dynamicClasses[agreementDetailStatus]['spanNum']
                      }
                    >
                      2
                    </span>
                  )}

                  <span
                    className={
                      dynamicClasses[agreementDetailStatus]['spanDetail']
                    }
                    style={{ width: '100%' }}
                  >
                    {t('Agreement Details')}
                  </span>
                  <span
                    className={
                      dynamicClasses[agreementDetailStatus]['spanDetail']
                    }
                    style={{
                      width: '100%',
                      float: 'left',
                      marginLeft: '-12px',
                      marginTop: '3px',
                    }}
                  >
                    {AgrId}
                  </span>
                </a>
              </ListItem>
              <ListItem className={wizardClassName.smartWizardList}>
                <a className={dynamicClasses[initialPaymentStatus]['anchor']}>
                  {initialPaymentStatus === 'complete' ? (
                    <Box
                      component="span"
                      className={`${wizardClassName.done} ${wizardClassName.borderDone}`}
                    >
                      <CompletedIcon className={wizardClassName.paddingTop3} />
                    </Box>
                  ) : (
                    <span
                      className={
                        dynamicClasses[initialPaymentStatus]['spanNum']
                      }
                    >
                      3
                    </span>
                  )}

                  <span
                    className={
                      dynamicClasses[initialPaymentStatus]['spanDetail']
                    }
                  >
                    {t('Initial Payment')}
                  </span>
                </a>
              </ListItem>
              <ListItem
                className={wizardClassName.smartWizardList}
                onClick={() => WizardFieldClick('DeliveryMethod')}
              >
                <a className={dynamicClasses[deliveryMethodStatus]['anchor']}>
                  {deliveryMethodStatus === 'complete' ? (
                    <Box
                      component="span"
                      className={`${wizardClassName.done} ${wizardClassName.borderDone}`}
                    >
                      <CompletedIcon className={wizardClassName.paddingTop3} />
                    </Box>
                  ) : (
                    <span
                      className={
                        dynamicClasses[deliveryMethodStatus]['spanNum']
                      }
                    >
                      4
                    </span>
                  )}

                  <span
                    className={
                      dynamicClasses[deliveryMethodStatus]['spanDetail']
                    }
                  >
                    {t('Delivery Method')}
                  </span>
                </a>
              </ListItem>
            </List>
          ) : null}
          <CustomerInfo
            CoCustomerDetails={CocustomerDetailsValue}
            dereceiver={dethrower}
            isNoDeStatus={1}
          />
        </Grid>
      </Grid>
    </div>
  );
}
